import { createSlice } from '@reduxjs/toolkit';
import { IProduct } from '../../../utils/models/Product';
import { v4 } from 'uuid';
import { IConfigurator } from '../configurator';
export interface IQuote {
  products: Array<{ id: string; item: IProduct; quantity: number }>;
  configurations: Array<{
    id: string;
    configuration: IConfigurator;
    quantity: number;
  }>;
}

const initialState: IQuote = {
  products: [],
  configurations: [],
};

const quoteSlice = createSlice({
  name: 'quote',
  initialState,
  reducers: {
    addProduct: (state, action) => {
      const products = [...state.products];
      const isDuplicate = products.find(
        (product: { id: string; item: IProduct; quantity: number }) =>
          product.item['articleNumber'] === action.payload.item['articleNumber']
      );
      if (isDuplicate) {
        products.forEach(
          (product: { id: string; item: IProduct; quantity: number }) =>
            (product.quantity =
              product.item['articleNumber'] ===
              action.payload.item['articleNumber']
                ? Number(product.quantity) + Number(action.payload.quantity)
                : Number(product.quantity))
        );
      } else {
        products.push({
          id: v4(),
          ...action.payload,
        });
      }
      state.products = products;
    },
    removeProduct: (state, action) => {
      state.products = state.products.filter(
        (product) => product.id !== action.payload
      );
    },
    updateProductQuantity: (state, action) => {
      state.products = state.products.map((pro) =>
        pro.id === action.payload.id
          ? { ...pro, quantity: action.payload.quantity }
          : pro
      );
    },

    removeQuotesProduct: (state, action) => {
      state.products = [...state.products].filter(
        (product) => product.id !== action.payload
      );
    },
    addConfiguration: (state, action) => {
      const configurations = [...state.configurations];
      configurations.push({
        id: v4(),
        ...action.payload,
      });
      state.configurations = configurations;
    },
    removeConfiguration: (state, action) => {
      state.configurations = [...state.configurations].filter(
        (configuration) => configuration.id !== action.payload
      );
    },
    updateConfigurationQuatity: (state, action) => {
      state.configurations = state.configurations.map((config) =>
        config.id === action.payload.id
          ? { ...config, quantity: action.payload.quantity }
          : config
      );
    },
    removeAllConfigurations: (state, action) => {
      state.configurations = action.payload.configurations;
      state.products = action.payload.products;
    },
  },
});

export const {
  addProduct,
  removeProduct,
  updateProductQuantity,
  removeQuotesProduct,
  addConfiguration,
  removeConfiguration,
  removeAllConfigurations,
  updateConfigurationQuatity,
} = quoteSlice.actions;

export default quoteSlice.reducer;
